import { Component, computed, inject } from '@angular/core';
import { WalletService } from '../../core/services/wallet.service';
import { NFTAssetPretty } from '../../shared/interfaces/nft.interface';

@Component({
  selector: 'app-nft-window',
  standalone: true,
  template: `
    <div class="nft-window-content">
      @if (walletConnection()?.actor) {
      <div class="wallet-info">
        Logged in as: <b>{{ walletConnection()?.actor }}</b>
      </div>
      }

      <div class="nft-section">
        <h3 style="margin: 5px">Choose your Cypher</h3>

        <div class="nft-grid">
          @for (nft of nftCollection(); track nft.asset_id) {
          <div class="nft-card">
            <h3>{{ nft.data['name'] || 'Unnamed NFT' }}</h3>

            @if (nft.imageUrl) {
            <img
              [src]="nft.imageUrl"
              [alt]="nft.name || 'NFT ' + nft.asset_id"
              style="min-width: 80px; max-width: 250px"
              loading="lazy"
              decoding="async"
              referrerpolicy="no-referrer"
              (error)="onNftImgError(nft)"
            />
            <p class="nft-meta">ID: {{ nft.asset_id }}</p>
            } @else {
            <div class="nft-placeholder">
              <span>Kein Bild gefunden</span>
              <small>ID: {{ nft.asset_id }}</small>
            </div>
            }
          </div>
          }
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./nft.component.scss'],
})
export class NftComponent {
  private readonly walletService = inject(WalletService);
  walletConnection = computed(() => this.walletService.walletConnection());
  nftCollection = computed(() => this.walletService.nftCollection());

  private ipfsGateways = [
    'https://ipfs.io/ipfs/',
    'https://cloudflare-ipfs.com/ipfs/',
    'https://gateway.pinata.cloud/ipfs/',
  ];

  onNftImgError(nft: NFTAssetPretty) {
    if (!nft.imageUrl) return;
    try {
      const u = new URL(nft.imageUrl);
      const parts = u.pathname.split('/').filter(Boolean);
      const hash = parts[1] || parts[0];
      const next =
        this.ipfsGateways.find((g) => nft?.imageUrl?.startsWith(g)) || this.ipfsGateways[0];
      nft.imageUrl = `${next}${hash}`;
    } catch {
      nft.imageUrl = null;
    }
  }
}
